import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import DripCampaignHeader from "./headers/drip-campaign-header";
import DripCampaignNavbar from "./drip-campaign-navbar";
import DripCampaignSearch from "./drip-campaign-search";
import DripCampaignTable from "./drip-campaign-table";
import DripCampaignTableLoader from "./drip-campaign-table-loader";
import DripCampaignNameModal from "./modals/drip-campaign-name-modal";
import DripCampaignClientsModal from "./modals/drip-campaign-clients-modal";
import { GET_ALL_CAMPAIGNS, CREATE_CAMPAIGN, GET_CAMPAIGN } from "../store/drip-campaign-actions";
import { UPDATE_CURRENT_TEMPLATE } from "@Broker/@Modules/marketing/store/templates/templates-actions";
import { LOAD_MARKETING_EMAILS } from "@Broker/@Modules/marketing/store/marketing/marketing-actions";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignContainer",
  title() {
    return this.$t("sidebar.sections.dripCampaigns");
  },
  components: {
    DripCampaignHeader,
    DripCampaignSearch,
    DripCampaignTable,
    DripCampaignTableLoader,
    DripCampaignNavbar,
    DripCampaignNameModal,
    DripCampaignClientsModal
  },
  data() {
    return {
      loading: {
        table: true,
        creatingCampaign: false
      },
      filter: "all",
      showClientsForCampaignId: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("DripCampaignStore", ["campaigns", "currentCampaign"])), {}, {
    filteredCampaigns() {
      return {
        all: this.campaigns,
        active: this.filterActiveCampaigns(this.campaigns),
        inactive: this.filterInActiveCampaigns(this.campaigns)
      };
    }
  }),
  activated() {
    this.getAllCampaigns();
    Amplitude.logEvent("Drip Campaigns - visited");
  },
  deactivated() {
    var _context;
    if (!_includesInstanceProperty(_context = this.$route.fullPath).call(_context, "/marketing/templates?fromCampaign=true")) {
      this.UPDATE_CURRENT_TEMPLATE({});
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [GET_ALL_CAMPAIGNS, CREATE_CAMPAIGN, GET_CAMPAIGN])), mapActions("TemplatesStore", [UPDATE_CURRENT_TEMPLATE])), mapActions("MarketingStore", [LOAD_MARKETING_EMAILS])), {}, {
    handleFilterChange(val) {
      this.filter = val;
    },
    filterActiveCampaigns(campaigns) {
      return _filterInstanceProperty(campaigns).call(campaigns, campaign => campaign.active);
    },
    filterInActiveCampaigns(campaigns) {
      return _filterInstanceProperty(campaigns).call(campaigns, campaign => !campaign.active);
    },
    handleShowCreateModal() {
      this.$refs.nameModal.showModal();
    },
    async handleShowClients(campaignId) {
      this.showClientsForCampaignId = campaignId;
      await this.$nextTick();
      this.$refs.clientsModal.showModal();
    },
    async getAllCampaigns() {
      this.loading.table = true;
      await this.GET_ALL_CAMPAIGNS();
      await this.LOAD_MARKETING_EMAILS();
      this.loading.table = false;
    },
    async handleCreateDripCampaign(name) {
      this.loading.creatingCampaign = true;
      const campaignId = await this.CREATE_CAMPAIGN(name);
      this.$router.push({
        path: `/automation/drip-campaigns/${campaignId}`
      });
      this.loading.creatingCampaign = false;
    }
  })
});